import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles } from '@material-ui/core'
import { Info, DoneAll, ShowChart } from '@material-ui/icons'
import { RobotIndustrial, FormatColorFill } from 'mdi-material-ui'
import NextButton from './NextButton'
import CancelButton from './CancelButton'
import Stepper from './Stepper'
import { stepperGoTo } from 'actions/view'

class StepperContainer extends Component {
  componentDidMount() {
    if (this.props.taskID === 'new') {
      this.props.stepperGoTo(0, 'task')
    }
  }

  componentWillUnmount() {
    this.props.stepperGoTo(0, 'task')
  }

  render() {
    const { selectedActionPrediction, stepper, taskID } = this.props

    const stepStyle = int => ({
      color: stepper === int ? '#18b940' : '#014c94',
    })

    const steps = () => {
      if (
        selectedActionPrediction === 'email' ||
        selectedActionPrediction === 'sms'
      ) {
        return [
          {
            label: 'Task',
            Icon: <Info style={stepStyle(0)} />,
          },
          {
            label: 'Automate',
            Icon: <RobotIndustrial style={stepStyle(1)} />,
          },
          {
            label:
              selectedActionPrediction === 'sms'
                ? 'Template '
                : 'Theme/Template',
            Icon: <FormatColorFill style={stepStyle(2)} />,
          },
          { label: 'Finalize', Icon: <DoneAll style={stepStyle(3)} /> },
          { label: 'Analyze', Icon: <ShowChart style={stepStyle(4)} /> },
        ]
      }

      return [
        {
          label: 'Task',
          Icon: <Info style={stepStyle(0)} />,
        },
        {
          label: 'Automate',
          Icon: <RobotIndustrial style={stepStyle(1)} />,
        },
        { label: 'Finalize', Icon: <DoneAll style={stepStyle(2)} /> },
        { label: 'Analyze', Icon: <ShowChart style={stepStyle(3)} /> },
        // { label: 'Email', Icon: <Mail /> },
      ]
    }

    return (
      <Grid
        container
        justify="space-between"
        className={
          this.props.modal
            ? this.props.classes.buttonsStyleModal
            : this.props.classes.buttonsStyle
        }
      >
        <Grid item>
          <CancelButton
            modal={this.props.modal}
            taskID={taskID}
            stepper={stepper}
          />
        </Grid>
        <Stepper
          selectedActionPrediction={selectedActionPrediction}
          taskID={taskID}
          steps={steps()}
        />
        <Grid item>
          <NextButton
            CustomCreateButton={this.props.CustomCreateButton}
            stepsLength={steps().length}
            stepper={stepper}
            taskID={taskID}
            modal={this.props.modal}
          />
        </Grid>
      </Grid>
    )
  }
}

const styles = theme => ({
  buttonsStyle: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      left: 0,
      top: 56,
    },
    width: 'calc(100% - 80px)',
    position: 'fixed',
    left: '80px',
    // bottom: '0px',
    top: 64,
    padding: '7.5px 12px',
    background: 'white',
    boxShadow: '0px 5px 5px #00000040',
    zIndex: 2,
    overflowY: 'hidden',
  },
  buttonsStyleModal: {
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      left: 0,
      // right: 0,
      // bottom: 0,
      top: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    width: 'calc(100% - 96px)',
    margin: 'auto',
    maxWidth: 1920,
    position: 'fixed',
    left: '48px',
    // bottom: '48px',
    top: 48,
    right: '48px',
    padding: '12px',
    background: 'white',
    boxShadow: '0px 5px 5px #00000040',
    borderTopLeftRadius: 28,
    borderTopRightRadius: 28,
    zIndex: 2,
    overflowY: 'hidden',
  },
})

export default connect(
  state => ({
    taskID: state.tasks.addOrEdit.taskID,
    selectedActionPrediction:
      state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    stepper: state.view.stepper.task,
  }),
  dispatch => bindActionCreators({ stepperGoTo }, dispatch),
)(withStyles(styles)(StepperContainer))
